module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-144x144-079e61089e7e6363928351f9eb0e6a25.png";